module.exports = __webpack_public_path__ + "static/media/sf_3400.b5736c056e85c838f8d5dcca156279e4.png";